/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAlertIntervalTypeFromJSON, ApiAlertIntervalTypeToJSON, } from './ApiAlertIntervalType';
import { ApiAlertNotificationResponseFromJSON, ApiAlertNotificationResponseToJSON, } from './ApiAlertNotificationResponse';
import { ApiAlertRequirementResponseFromJSON, ApiAlertRequirementResponseToJSON, } from './ApiAlertRequirementResponse';
import { ApiAlertTypeFromJSON, ApiAlertTypeToJSON, } from './ApiAlertType';
export function ApiAlertResponseFromJSON(json) {
    return ApiAlertResponseFromJSONTyped(json, false);
}
export function ApiAlertResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chartNotifications': !exists(json, 'chartNotifications') ? undefined : (json['chartNotifications'].map(ApiAlertNotificationResponseFromJSON)),
        'checkedAt': !exists(json, 'checkedAt') ? undefined : (new Date(json['checkedAt'])),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'emails': !exists(json, 'emails') ? undefined : json['emails'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'interval': !exists(json, 'interval') ? undefined : json['interval'],
        'intervalType': !exists(json, 'intervalType') ? undefined : ApiAlertIntervalTypeFromJSON(json['intervalType']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notifiedAt': !exists(json, 'notifiedAt') ? undefined : (new Date(json['notifiedAt'])),
        'requirements': !exists(json, 'requirements') ? undefined : (json['requirements'].map(ApiAlertRequirementResponseFromJSON)),
        'type': !exists(json, 'type') ? undefined : ApiAlertTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiAlertResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chartNotifications': value.chartNotifications === undefined ? undefined : (value.chartNotifications.map(ApiAlertNotificationResponseToJSON)),
        'checkedAt': value.checkedAt === undefined ? undefined : (value.checkedAt.toISOString()),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'description': value.description,
        'emails': value.emails,
        'id': value.id,
        'interval': value.interval,
        'intervalType': ApiAlertIntervalTypeToJSON(value.intervalType),
        'name': value.name,
        'notifiedAt': value.notifiedAt === undefined ? undefined : (value.notifiedAt.toISOString()),
        'requirements': value.requirements === undefined ? undefined : (value.requirements.map(ApiAlertRequirementResponseToJSON)),
        'type': ApiAlertTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
